/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackGeneralAnalysisJSX } from '../../analysisJSX/viewFeedbackGeneralAnalysisJSX'
import { viewFeedbackScorecardJSX } from '../../analysisJSX/viewFeedbackScorecardJSX'
import { viewFeedbackAndVerdictForItemJSX } from '../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { giveElementFeedbackJSX } from '../../analysisJSX/giveElementFeedbackJSX'
import { viewTinderNameAndPronounsItem } from './jsx/viewTinderNameAndPronounsItemJSX'
import { viewTinderVitalInfoItem, showLifestyleJSX, showLookingForJSX, tinderLifestyleJSX, tinderLookingForJSX } from './jsx/viewTinderVitalInfoItemJSX'
import { viewTinderImages } from './jsx/viewTinderImagesJSX'
import { viewTinderPromptItem } from './jsx/viewTinderPromptItemJSX'
import { viewTinderAboutMeItem } from './jsx/viewTinderAboutMeItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, tinderProfileBackgroundColor, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileTextColor, tinderProfilePromptTextColor, tinderProfileItemDividerOpacity, tinderProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileImageWidth, tinderProfileImageIndicatorWidth, tinderLeadImageHeight, tinderImageHeight, swipelyticsTurquoise, profPicDefaultURL } from '../../../../helpers/variableDefaults'
import { standardSpinner } from '../../../../helpers/spinners'
import { TabPanel } from '../../../../helpers/formatting'


export const viewTinderProfileJSX = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, datingProfile, user, viewTinderImageIndex, setViewTinderImageIndex, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview) => {
  
  return (
    <Box sx={{ 
      // backgroundColor: 'yellow',
      mt: 0, mb: 0, 
      // width: '90vw', 
      width: width >= positionChangeWidthSm ? '90vw' : '100vw', 
      maxWidth: positionChangeWidthSm, 
      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
    }}>
      <Box
        sx={{
          mt: 2, mb: (giveFeedbackTrue || viewFeedbackTrue) ? 2 : 4, py: 3, px: 2,
          backgroundColor: tinderProfileBackgroundColor,
          // backgroundColor: 'black',
          width: '100%', 
          // maxWidth: '600px',
          maxWidth: '400px',
          boxShadow: width >= positionChangeWidthSm ? 3 : 3, 
          borderRadius: width >= positionChangeWidthSm ? 3 : 0,
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* Name and Pronouns */}
        {'bio' in datingProfile 
          && 'vitalInfo' in datingProfile.bio 
          && 'firstName' in datingProfile.bio.vitalInfo 
          &&
            viewTinderNameAndPronounsItem(
              datingProfile, 
              width
            )
        }

        {/* Image 1 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 0 
          && 
            viewTinderImages(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              viewTinderImageIndex, 
              datingProfile, 
              viewTinderImageIndex, 
              setViewTinderImageIndex, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Images  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 0 
          && 'feedback' in datingProfile.mediaFeedback[0] 
          && 'verdict' in datingProfile.mediaFeedback[0] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            viewTinderImageIndex, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* About Me */}
        {'bio' in datingProfile
          && 'aboutMe' in datingProfile.bio
          && datingProfile.bio.aboutMe.length > 0
          &&
            viewTinderAboutMeItem(
              viewFeedbackTrue,
              giveFeedbackTrue, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — About Me */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'aboutMeFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.aboutMeFeedback !== null
          && Object.keys(datingProfile.bioFeedback.aboutMeFeedback).length > 0 
          && 'feedback' in datingProfile.bioFeedback.aboutMeFeedback 
          && 'verdict' in datingProfile.bioFeedback.aboutMeFeedback 
          && 
          giveElementFeedbackJSX(
            'aboutMe', 
            -1, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Prompt 1 */}
        {'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length > 0
          && datingProfile.bio.prompts[0].prompt !== '' 
          && datingProfile.bio.prompts[0].prompt !== 'No Prompt' 
          && datingProfile.bio.prompts[0].response !== ''
          &&
            viewTinderPromptItem(
              viewFeedbackTrue,
              giveFeedbackTrue, 
              0, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Prompt 1  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'promptsFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.promptsFeedback.length > 0 
          && 'feedback' in datingProfile.bioFeedback.promptsFeedback[0] 
          && 'verdict' in datingProfile.bioFeedback.promptsFeedback[0] 
          && 
          giveElementFeedbackJSX(
            'prompt', 
            0, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Vital Info */}
        {'bio' in datingProfile
          && 'vitalInfo' in datingProfile.bio
          && Object.keys(datingProfile.bio.vitalInfo).length > 0
          &&
            viewTinderVitalInfoItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              isFriendReview,
              user, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Vital Info  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'vitalInfoFeedback' in datingProfile.bioFeedback 
          && 'feedback' in datingProfile.bioFeedback.vitalInfoFeedback 
          && 'verdict' in datingProfile.bioFeedback.vitalInfoFeedback 
          && 
          giveElementFeedbackJSX(
            'vitalInfo', 
            -1, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Prompt 2 */}
        {'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length > 1
          && datingProfile.bio.prompts[1].prompt !== '' 
          && datingProfile.bio.prompts[1].prompt !== 'No Prompt' 
          && datingProfile.bio.prompts[1].response !== ''
          &&
            viewTinderPromptItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              1, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Prompt 2  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'promptsFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.promptsFeedback.length > 1 
          && 'feedback' in datingProfile.bioFeedback.promptsFeedback[1] 
          && 'verdict' in datingProfile.bioFeedback.promptsFeedback[1] 
          && 
          giveElementFeedbackJSX(
            'prompt', 
            1, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Looking For */}
        {!(viewFeedbackTrue || giveFeedbackTrue)
          && 'bio' in datingProfile
          && 'vitalInfo' in datingProfile.bio
          && Object.keys(datingProfile.bio.vitalInfo).length > 0
          && showLookingForJSX(datingProfile)
          &&
            <Box
              sx={{
                mt: 2, 
                // px: 2, py: 2,
                width: tinderProfileImageWidth(width),
                backgroundColor: tinderProfileItemBackgroundColor,
                boxShadow: tinderProfileItemBoxShadow, 
                borderRadius: tinderProfileItemBorderRadius,
              }}
            >
              {tinderLookingForJSX(
                viewFeedbackTrue, 
                giveFeedbackTrue,
                isFriendReview,
                user, 
                datingProfile, 
                width
              )}
            </Box>
        }

        {/* Prompt 3 */}
        {'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length > 2
          && datingProfile.bio.prompts[2].prompt !== '' 
          && datingProfile.bio.prompts[2].prompt !== 'No Prompt' 
          && datingProfile.bio.prompts[2].response !== ''
          &&
            viewTinderPromptItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              2, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Prompt 3  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'promptsFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.promptsFeedback.length > 2 
          && 'feedback' in datingProfile.bioFeedback.promptsFeedback[2] 
          && 'verdict' in datingProfile.bioFeedback.promptsFeedback[2] 
          && 
          giveElementFeedbackJSX(
            'prompt', 
            2, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Lifestyle */}
        {!(viewFeedbackTrue || giveFeedbackTrue)
          && 'bio' in datingProfile
          && 'vitalInfo' in datingProfile.bio
          && Object.keys(datingProfile.bio.vitalInfo).length > 0
          && showLifestyleJSX(datingProfile)
          &&
            <Box
              sx={{
                mt: 2, 
                // px: 2, py: 2,
                width: tinderProfileImageWidth(width),
                backgroundColor: tinderProfileItemBackgroundColor,
                boxShadow: tinderProfileItemBoxShadow, 
                borderRadius: tinderProfileItemBorderRadius,
              }}
            >
              {tinderLifestyleJSX(
                viewFeedbackTrue, 
                giveFeedbackTrue,
                isFriendReview,
                user, 
                datingProfile, 
                width
              )}
            </Box>
        }

        {/* Analysis */}
        {viewFeedbackTrue 
          && 'generalFeedback' in datingProfile 
          && Object.keys(datingProfile.generalFeedback).length > 0
          && 
          (
            ('vibe' in datingProfile.generalFeedback && datingProfile.generalFeedback.vibe.length > 0)
            || ('good' in datingProfile.generalFeedback && datingProfile.generalFeedback.good.length > 0)
            || ('notGood' in datingProfile.generalFeedback && datingProfile.generalFeedback.notGood.length > 0)
            || ('verdict' in datingProfile.generalFeedback && datingProfile.generalFeedback.verdict.length > 0)
          )
          &&
          viewFeedbackGeneralAnalysisJSX(datingProfile.type, datingProfile.generalFeedback, datingProfile.bio.vitalInfo, width)
        }
        
        {/* Scorecard */}
        {/* {console.log('datingProfile.mediaFeedback.length ->', datingProfile)} */}
        {viewFeedbackTrue 
          && 'mediaFeedback' in datingProfile && datingProfile.mediaFeedback.length > 0 &&
          viewFeedbackScorecardJSX(datingProfile.type, datingProfile.mediaFeedback, datingProfile.bioFeedback, width)
        }
      </Box>
    </Box>
  )
}

export const viewTinderProfileTabJSX = (value, index, giveFeedbackTrue, isFriendReview, datingProfile, user, viewTinderImageIndex, setViewTinderImageIndex, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview) => {

  return (
    <TabPanel value={value} index={index}>
      {loading.loading ?
        standardSpinner()
        : 
        viewTinderProfileJSX(
          giveFeedbackTrue && datingProfile.reviewSubmitted ? true : false, 
          giveFeedbackTrue && datingProfile.reviewSubmitted ? false : giveFeedbackTrue,
          isFriendReview,
          datingProfile,
          user, 
          viewTinderImageIndex, 
          setViewTinderImageIndex,
          showSubcaption, 
          setShowSubcaption, 
          mediaIsLoading, 
          setMediaIsLoading,
          loading, 
          setLoading, 
          errors, 
          setErrors, 
          width,
          setProfileReview
        )
      }
    </TabPanel>
  )
}